<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<QueryCondition @query="query" @exportExcel="exportExcel" ref="queryCondition" />
			
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
								
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition7'
	import TableFuncs from '../../components/statistics/TableFuncs'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams: {
					appKey: null,
					startDate: null,
					endDate: null,
				},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '类型',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.type;
							if (val == '1') {
								name = '建议'
							} else {
								name = '投诉'
							}
							return h('span', name)
						}
					},
					{
						width: 200,
						title: '用户手机/微信号',
						key: 'phone',
						align: 'center',
						tooltip:true
					},
					{
						width: 200,
						title: '投诉问题',
						key: 'title',
						align: 'center',
						tooltip:true
					},					
					{
						title: '建议内容',
						key: 'content',
						align: 'center',
						tooltip:true
					}, {
						width: 180,
						title: '创建日期',
						key: 'createTime',
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			refreshData() {
				this.pageNum = 1,
					this.queryData = []
				this.getData()
			},
			getData() {
				this.loading = true
				console.log(this.queryParams)
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					appKey: this.queryParams.appKey,
					startDate: this.queryParams.startDate,
					endDate: this.queryParams.endDate,
				}
				api.statistics
					.getAdvicePage(queryParams)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据列表失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			
		},



	}
</script>
